import { Button } from 'primereact/button';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AxiosConexionConfig from '../../components/Conexion/AxiosConexionConfig';
import { apiGetPlantas } from '../../Config/const';

const DiscoverGPMPlants = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleGPMSyncBtn = async () => {
    setLoading(true);
    const urlDiscoverPlants = apiGetPlantas + '/discover-plants-from-gpm-api';
    await AxiosConexionConfig.get(urlDiscoverPlants);

    const urlDiscoverDatasources =
      apiGetPlantas + '/discover-datasources-from-gpm-api';
    await AxiosConexionConfig.get(urlDiscoverDatasources);

    setLoading(false);
  };

  return (
    <div>
      <Button
        type="button"
        className={`p-button p-mr-2 p-mb-2 buttonColor text ${
          loading && 'pointer-events-none'
        }`}
        onClick={handleGPMSyncBtn}
        style={{
          backgroundColor: '#10304C',
          color: '#f5a508',
        }}
      >
        <i className={`pi ${loading ? 'pi-spin pi-spinner' : 'pi-replay'}`}></i>
        <label className="marginLeft10px">{t('Sincronizar con API GPM')}</label>
      </Button>
    </div>
  );
};

export default DiscoverGPMPlants;
